'use client';
import Navigation, { NavigationProps as BaseNavigationProps } from '@repo/ui/src/components/Navigation';
import NavbarBrand from '@components/Navbar/_Brand';
import NavbarShoppingCart from '@components/Navbar/_ShoppingCart';
import UserAvatar from '@components/Navbar/_UserAvatar';
import SocialLinks from '@components/SocialLinks';
import { useKeyboardNavigation } from '@hooks/useKeyboardNavigation';
import { useOnRouteChange } from '@hooks/useOnRouteChange';
import { useCustomer } from '@hooks/customer';
import { useLogout } from '@hooks/auth';
import { getTZDate } from '@components/Navbar/SiteWideBanner/_CountdownClock';
import LanguageSelectorData from '@components/LanguageSelector/LanguageSelectorData.json';
import dynamic from 'next/dynamic';

const CountDownClock = dynamic(() => import('@components/Navbar/SiteWideBanner/_CountdownClock'));

// Extend the base props with traeger-specific requirements
export type NavigationProps = Omit<BaseNavigationProps, 'NavbarBrand' | 'NavbarShoppingCart' | 'UserAvatar' | 'useKeyboardNavigation' | 'useOnRouteChange' | 'useCustomer' | 'useLogout' | 'SocialLinks'>;

// Re-export types that other components might need
export type { NavItemProps } from '@repo/ui/src/components/Navigation';
export { isDropdown, useNavigationContext } from '@repo/ui/src/components/Navigation';

const TraegerNavigation = (props: NavigationProps) => {
  return (
    <Navigation
      {...props}
      regions={LanguageSelectorData.regions}
      NavbarBrand={NavbarBrand}
      NavbarShoppingCart={NavbarShoppingCart}
      UserAvatar={UserAvatar}
      useKeyboardNavigation={useKeyboardNavigation}
      useOnRouteChange={useOnRouteChange}
      useCustomer={useCustomer}
      useLogout={useLogout}
      SocialLinks={SocialLinks}
      getTZDate={getTZDate}
      CountDownClock={CountDownClock}
    />
  );
};

export default TraegerNavigation;